import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

domReady(() => {
  const newsEventsCarousels = document.querySelectorAll(
    '.block-news-events .block-news-events__carousel'
  );

  if (0 < newsEventsCarousels.length) {
    newsEventsCarousels.forEach((newsEventsCarousel) => {
      new Swiper(newsEventsCarousel, {
        slidesPerView: 1.15,
        spaceBetween: 20,
        pagination: {
          el: '.block-news-events .vtx-swiper__pagination',
          type: 'fraction',
        },
        navigation: {
          nextEl: '.block-news-events .swiper-button-next.vtx-swiper__next',
          prevEl: '.block-news-events .swiper-button-prev.vtx-swiper__prev',
        },
        breakpoints: {
          768: {
            slidesPerView: 2.25,
            spaceBetween: 20,
          },
          1080: {
            slidesPerView: 3.15,
            spaceBetween: 20,
          },
        },
      });
    });
  }
});
